<template>
  <ClientOnly>
    <Swiper
      :modules="[Navigation]"
      :slides-per-view="2.1"
      :slides-per-group="1"
      :slides-offset-before="0"
      :slides-offset-after="0"
      :space-between="12"
      :class="swiperClasses"
      navigation
      :breakpoints="{
        490: {
          slidesPerView: 2.2,
          slidesPerGroup: 2,
          spaceBetween: 12,
          slidesOffsetBefore: 0,
          slidesOffsetAfter: 0
        },
        768: {
          slidesPerView: 3.35,
          slidesPerGroup: 3,
          spaceBetween: 16,
          slidesOffsetBefore: 0,
          slidesOffsetAfter: 0
        },
        1024: {
          slidesPerView: 4.45,
          slidesPerGroup: 4,
          spaceBetween: 16,
          slidesOffsetBefore: 0,
          slidesOffsetAfter: 0
        },
        1440: {
          slidesPerView: 4,
          slidesPerGroup: 4,
          spaceBetween: 16,
          slidesOffsetBefore: 0,
          slidesOffsetAfter: 0
        }
      }"
      :loop="false"
      :pagination="{
        clickable: true
      }"
    >
      <slot />
    </Swiper>
    <template #placeholder>
      <div class="h-[450px] bg-white/20 animate-fadepulse" />
    </template>
  </ClientOnly>
</template>

<script setup lang="ts">
import { Swiper } from 'swiper/vue'
import { Navigation } from 'swiper/modules'

defineProps({
  swiperClasses: {
    type: String,
    default: ''
  }
})
</script>
